export default __webpack_public_path__ + "static/media/house.4473d936.svg";